import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentUserGetAudioTemplatesResponse {
  audios: Array<AudioTemplates>;
  total: number;
  current_page: number;
  page_size: number;
  total_pages: number;
};
export interface AudioTemplates {
  id: string;
  name: string;
  provider: string;
  sample_url: string;
  use_count: number;
  star_count: number;
  voice_tts_id: string;
  process_status: number;
  description: string;
  input_text: string;
  task_id: string;
  user_id: number;
  publish_state: string;
  created_at: Date;
  updated_at: Date;
};

// 请求接口
interface AgentUserGetAudioTemplatesRequest {
  agentId: string,
  userId: string,
  page: number,
  pageSize: number
}

export class AudioTemplatesData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Provider cannot be empty")
  @IsString("Provider must be a string")
  provider: string;

  @Required("Sample url cannot be empty")
  @IsString("Sample url must be a string")
  sampleUrl: string;

  @Required("Use count cannot be empty")
  @IsNumber("Use count must be a number")
  useCount: number;

  @Required("Star count cannot be empty")
  @IsNumber("Star count must be a number")
  starCount: number;

  @Required("Voice tts id cannot be empty")
  @IsString("Voice tts id must be a string")
  voiceTtsId: string;

  @Required("Process status cannot be empty")
  @IsNumber("Process status must be a number")
  processStatus: number;

  @Required("Description cannot be empty")
  @IsString("Description must be a string")
  description: string;

  @Required("Input text cannot be empty")
  @IsString("Input text must be a string")
  inputText: string;

  @Required("Task id cannot be empty")
  @IsString("Task id must be a string")
  taskId: string;

  @Required("User id cannot be empty")
  @IsNumber("User id must be a number")
  userId: number;

  @Required("Publish state cannot be empty")
  @IsString("Publish state must be a string")
  publishState: string;

  @Required("Created at cannot be empty")
  @IsString("Created at must be a string")
  createdAt: string;

  @Required("Updated at cannot be empty")
  @IsString("Updated at must be a string")
  updatedAt: string;
}

export class AgentUserGetAudioTemplatesData {
  // @Required("Audios cannot be empty")
  @IsArray("Audios must be an array")
  audios: Array<AudioTemplatesData>;

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Current page cannot be empty")
  @IsNumber("Current page must be a number")
  currentPage: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;

  @Required("Total pages cannot be empty")
  @IsNumber("Total pages must be a number")
  totalPages: number;
}

const transformAndValidateAgent = (
  response: AgentUserGetAudioTemplatesResponse
): AgentUserGetAudioTemplatesData => {
  const transformedData = transformKeys(response);

  try {
    const data = DataValidator.validateOrThrow(transformedData, AgentUserGetAudioTemplatesData);
    if (!data.audios) {
      data.audios = [];
    }
    return data;
  } catch (error) {
    console.error("Agent User data validation failed:", error.message);
    throw error;
  }
};

/** 获取 Agent 用户音频模板列表 */
export const agentUserGetAudioTemplates = async ({
  agentId,
  userId,
  page,
  pageSize,
}: AgentUserGetAudioTemplatesRequest): Promise<AgentUserGetAudioTemplatesData> => {
  const response = await api.post<AgentUserGetAudioTemplatesResponse>('/agent/user/get-audio-templates', {
    agent_id: agentId,
    user_id: userId,
    page_size: pageSize,
    page,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
